export function setCache (key, value) {
    if (typeof value === 'object') {
        return localStorage.setItem(key, JSON.stringify(value));
    } else {
        return localStorage.setItem(key, value);
    }
}

export function getCache (key) {
    const value = localStorage.getItem(key);
    if (value) {
        try {
            // 身份证号不需要解析
            if(key === 'user_idCard') return value;
            return JSON.parse(value);
        } catch (error) {
            return value;
        }
    }
    return null;
}

export function clearCache (key) {
    localStorage.removeItem(key);
}